import React, { useState, useCallback, useEffect, useMemo } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Icon,
  Autocomplete,
  Select,
  Divider,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate, useParams } from "react-router-dom";
import { usavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import Select2 from "react-select";
import { SearchIcon } from "@shopify/polaris-icons";
import { PlusIcon } from "@shopify/polaris-icons";
import JoditEditor from "jodit-react";
import { EDITOR_CONFIG } from "../../../constants";
import { MultiSelect } from "react-multi-select-component";

const AddEditSession = (props) => {
  const navigate = useNavigate();
  const { id, sessionId } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [item, setItem] = useState({
    isActive: true,
    instructor: "",
    instructors: [],
    date: "",
    start_time: "",
    end_time: "",
    capacity_female: "",
    capacity_male: "",
    total_capacity: "",
    gender: "",
    canvas_height: "",
    instructor_x: "",
    instructor_y: "",
    instructor_rotation: "",
    time_ranges: [{ from_time: "", to_time: "" }],
    time_slots: [],
    location: "default",
    location_other: "",
    room: "",
    is_private: false,
    name: "",
    description: "",
    is_booking_exists: false,
    class: "",
    external_capacity: "",
    is_online: false,
    zoom_meeting_url: "",
    is_discount_enabled: false,
  });
  const handleChangeExternalCapacity = (newValue) => {
    setItem({ ...item, external_capacity: newValue });
  };
  const handleChangeIsOnline = (newValue) => {
    setItem({ ...item, is_online: newValue });
  };
  const handleChangeZoomMeetingUrl = (newValue) => {
    setItem({ ...item, zoom_meeting_url: newValue });
  };
  const handleChangeIsDiscountEnabled = (newValue) => {
    setItem({ ...item, is_discount_enabled: newValue });
  };
  const handleChangeName = (newValue) => {
    setItem({ ...item, name: newValue });
  };
  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };
  const handleChangeDate = (newValue) => {
    setItem({ ...item, date: newValue });
    setDateError("");
  };
  const [dateError, setDateError] = useState("");
  const handleChangeLocation = (newValue) => {
    setItem({ ...item, location: newValue });
    setLocationError("");
  };
  const [locationError, setLocationError] = useState("");
  const handleChangeRoom = (newValue) => {
    setItem({ ...item, room: newValue });
  };
  const handleChangeLocationOther = (newValue) => {
    setItem({ ...item, location_other: newValue });
    setOtherLocationError("");
  };
  const [otherLocationError, setOtherLocationError] = useState("");
  const handleChangeStartTime = (newValue) => {
    setItem({ ...item, start_time: newValue });
    setStartTimeError("");
  };
  const [startTimeError, setStartTimeError] = useState("");
  const handleChangeEndTime = (newValue) => {
    setItem({ ...item, end_time: newValue });
    setEndTimeError("");
  };
  const [endTimeError, setEndTimeError] = useState("");
  const handleSelectChangeInstructor = (newValue) => {
    setItem({ ...item, instructor: newValue });
    setInstructorError("");
  };
  const handleSelectChangeClass = (newValue) => {
    setItem({ ...item, class: newValue });
  };
  const [instructorError, setInstructorError] = useState("");
  const handleChangeTimeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const optionsGenders = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Mixed (With male,female capacities)", value: "mixed" },
    { label: "Mixed (With total capacity)", value: "mixed_total" },
  ];
  const handleSelectChangeGender = (newValue) => {
    setItem({ ...item, gender: newValue });
    setGenderError("");
  };
  const [genderError, setGenderError] = useState("");
  const handleChangeCapacityMale = (newValue) => {
    setItem({ ...item, capacity_male: newValue });
    setMaleCapacityError("");
  };
  const [maleCapacityError, setMaleCapacityError] = useState("");
  const handleChangeCapacityFemale = (newValue) => {
    setItem({ ...item, capacity_female: newValue });
    setFemaleCapacityError("");
  };
  const [femaleCapacityError, setFemaleCapacityError] = useState("");
  const handleChangeCapacityTotal = (newValue) => {
    setItem({ ...item, total_capacity: newValue });
    setTotalCapacityError("");
  };
  const [totalCapacityError, setTotalCapacityError] = useState("");
  const [optionsInstructors, setOptionsInstructors] = useState([]);
  const [optionsClasses, setOptionsClasses] = useState([]);
  const [optionsRooms, setOptionsRooms] = useState([]);
  const [optionsUsers, setOptionsUsers] = useState([]);
  const handleChangeUser = (newValue) => {
    setUser(newValue);
    setUserError("");
  };
  const [userError, setUserError] = useState("");
  const [method, setMethod] = useState("");
  const [seats, setSeats] = useState([]);
  const handleChangeMethod = (newValue) => {
    setMethod(newValue);
    setMethodError("");
  };
  const [methodError, setMethodError] = useState("");
  const [seat, setSeat] = useState("");
  const handleChangeSeat = (newValue) => {
    setSeat(newValue);
    setSeatError("");
  };
  const [seatError, setSeatError] = useState("");
  const [user, setUser] = useState("");
  const [classType, setClassType] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseItem = "";
    let responseInstructors = [];
    let responseRooms = [];
    let responseUsers = "";
    let responseClass = "";
    let responseClasses = [];
    try {
      responseInstructors = await axios.get(`/instructors-list`);
      console.log("insss=", responseInstructors.data.data);
      setOptionsInstructors(
        responseInstructors.data.data.map((item, index) => {
          return {
            label: item.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    try {
      responseRooms = await axios.get(`/rooms?per_page=10000`);
      responseRooms.data.data.data &&
        setOptionsRooms(
          responseRooms.data.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }

    if (props.type === "edit") {
      try {
        responseItem = await axios.get(
          `/${
            props?.is_course === "yes" ? "courses" : "classes"
          }/${id}/sessions/${sessionId}`
        );
        console.log("gender=", responseItem?.data?.data);
        setItem({
          date: responseItem?.data?.data?.date
            ? responseItem.data.data.date
            : "",
          isActive: responseItem?.data?.data?.is_active ? true : false,
          start_time:
            props?.is_course === "yes"
              ? responseItem?.data?.data?.start_time || ""
              : responseItem?.data?.data?.launch_time || "",
          end_time:
            props?.is_course === "yes"
              ? responseItem?.data?.data?.end_time || ""
              : responseItem?.data?.data?.finish_time || "",
          gender: responseItem?.data?.data?.gender
            ? responseItem.data.data.gender
            : "",
          capacity_female:
            responseItem?.data?.data?.capacity_female !== "" &&
            responseItem?.data?.data?.capacity_female !== null
              ? responseItem.data.data.capacity_female
              : "",
          capacity_male:
            responseItem?.data?.data?.capacity_male !== "" &&
            responseItem?.data?.data?.capacity_male !== null
              ? responseItem.data.data.capacity_male
              : "",
          total_capacity:
            responseItem?.data?.data?.capacity !== "" &&
            responseItem?.data?.data?.capacity !== null
              ? responseItem.data.data.capacity
              : "",
          room:
            responseItem?.data?.data?.room_id !== null
              ? String(responseItem.data.data.room_id)
              : "",
          instructor:
            props?.is_course !== "yes"
              ? responseItem?.data?.data?.instructor
                ? {
                    label: responseItem?.data?.data?.instructor?.name,
                    value: String(responseItem?.data?.data?.instructor?.id),
                  }
                : ""
              : "",
          instructors:
            props?.is_course === "yes"
              ? responseItem?.data?.data?.instructors &&
                responseItem?.data?.data?.instructors.length
                ? responseItem?.data?.data?.instructors.map((item) => ({
                    label: item.name,
                    value: String(item.id),
                  }))
                : []
              : [],
          class: responseItem?.data?.data?.related_class
            ? {
                label: responseItem?.data?.data?.related_class?.name,
                value: String(responseItem?.data?.data?.related_class?.id),
              }
            : "",
          time_ranges:
            responseItem?.data?.data?.time &&
            responseItem?.data?.data?.time.length
              ? responseItem?.data?.data?.time
              : [],
          time_slots:
            responseItem?.data?.data?.time_slots &&
            responseItem?.data?.data?.time_slots.length
              ? responseItem?.data?.data?.time_slots
              : [],
          location: responseItem?.data?.data?.location
            ? responseItem.data.data.location
            : "",
          location_other: responseItem?.data?.data?.other_location
            ? responseItem.data.data.other_location
            : "",
          name: responseItem?.data?.data?.name
            ? responseItem.data.data.name
            : "",
          room: responseItem?.data?.data?.room
            ? String(responseItem.data.data.room)
            : "",
          description: responseItem?.data?.data?.description
            ? responseItem.data.data.description
            : "",
          is_booking_exists: responseItem?.data?.data?.is_booking_exists,
          external_capacity: responseItem?.data?.data?.external_capacity || "",
          is_online: responseItem?.data?.data?.is_online ? true : false,
          zoom_meeting_url: responseItem?.data?.data?.zoom_meeting_url || "",
          is_discount_enabled: responseItem?.data?.data?.is_discount_enabled ? true : false,
        });
      } catch (error) {
        console.log(error);
      }
    }

    if (props?.is_course !== "yes")
      try {
        responseClasses = await axios.get(
          `/classes-list?filter[type]=${responseItem.data.data.related_class.type}`
        );
        setOptionsClasses(
          responseClasses.data.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
            };
          })
        );
      } catch (error) {
        console.log(error);
      }
    try {
      responseClass = await axios.get(
        `/${props?.is_course === "yes" ? "courses" : "classes"}/${id}`
      );
      responseClass.data.data.type === "spot" &&
        setSeats(
          responseClass.data.data.seats.map((item, index) => {
            return {
              label: item.label,
              value: String(item.id),
            };
          })
        );

      console.log("tessst=", responseClass?.data?.data?.is_private);
      setClassType(responseClass.data.data.type);
      setItem((prevItem) => ({
        ...prevItem,
        is_private: responseClass?.data?.data?.is_private,
      }));
    } catch (error) {
      console.log(error);
    }

    // try {
    //   responseUsers = await axios.get(
    //     `/app/classes/${id}/private-users?per_page=1000`
    //   );
    //   setOptionsUsers(
    //     responseUsers.data.data.map((item, index) => {
    //       return {
    //         label: item.first_name + " " + item.last_name,
    //         value: String(item.id),
    //       };
    //     })
    //   );
    // } catch (error) {
    //   console.log(error);
    // }
    setIsSaving(false);
  }

  useEffect(() => {
    props?.is_course !== "yes" &&
      axios
        .get(
          `/app/${
            props?.is_course === "yes" ? "courses" : "classes"
          }/${id}/private-users${item.gender ? `?gender=${item.gender}` : ""}`
        )
        .then((result) => {
          setOptionsUsers(
            result.data.data.map((item, index) => {
              return {
                label: item.first_name + " " + item.last_name,
                value: String(item.id),
              };
            })
          );
        })
        .catch((err) => console.log(err));
  }, [item.gender]);

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have be saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const handleAddTime = () => {
    setItem({
      ...item,
      time_ranges: [...item.time_ranges, { from_time: "", to_time: "" }],
    });
  };
  const handleRemoveTime = (index) => {
    const updatedRanges = [...item.time_ranges];
    updatedRanges.splice(index, 1);
    setItem({ ...item, time_ranges: updatedRanges });
  };
  const handleChangeTime = (index, field, value) => {
    const updatedRanges = [...item.time_ranges];
    updatedRanges[index][field] = value;
    setItem({ ...item, time_ranges: updatedRanges });
  };

  const [error, setError] = useState("");
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Session`}
      backAction={{
        onAction: () => navigate(`/admin/${props.path}/${id}/sessions`),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          {props?.type === "edit" && props?.is_course !== "yes" ? (
            <div>
              <Text>Class</Text>
              <Select2
                options={optionsClasses}
                onChange={handleSelectChangeClass}
                value={item.class}
                placeholder="Please select"
                styles={{
                  // Fixes the overlapping problem of the compont
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
              />
            </div>
          ) : null}
          <TextField
            value={item.name}
            onChange={handleChangeName}
            label="Name"
          />
          <Text>Description </Text>
          <JoditEditor
            value={item.description}
            config={EDITOR_CONFIG}
            onBlur={handleChangeDescription}
          />
          {props?.is_course === "yes" ? (
            <FormLayout>
              <Text>Instructors</Text>
              <div
                style={{
                  position: "relative",
                  zIndex: 9999,
                  // marginBottom: "400px",
                }}
              >
                <MultiSelect
                  options={optionsInstructors}
                  onChange={(e) => {
                    setItem({ ...item, instructors: e });
                  }}
                  value={item.instructors}
                  placeholder="Please select"
                />
                {/* <MultiSelect
                  value={item.instructors}
                  options={optionsInstructors}
                  onChange={(e) => {
                    console.log("test=", e.value);
                    setItem({ ...item, instructors: e.value });
                  }}
                  filter={true}
                  placeholder="Please select"
                  style={{ width: "100%" }}
                  selectAllLabel="Select All"
                  display="chip"
                /> */}
              </div>
            </FormLayout>
          ) : (
            <FormLayout>
              <Text>Instructor</Text>
              <Select2
                options={optionsInstructors}
                onChange={handleSelectChangeInstructor}
                value={item.instructor}
                placeholder="Please select"
                styles={{
                  // Fixes the overlapping problem of the compont
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
              />
            </FormLayout>
          )}

          <InlineError message={instructorError} />
          <FormLayout.Group condensed>
            <TextField
              value={item.date}
              onChange={handleChangeDate}
              label="Date"
              error={dateError}
              type="date"
            />
            {classType !== "duration" && (
              <TextField
                value={item.start_time}
                onChange={handleChangeStartTime}
                label="Start Time"
                error={startTimeError}
                type="time"
              />
            )}
            {classType !== "duration" && (
              <TextField
                value={item.end_time}
                onChange={handleChangeEndTime}
                label="End Time"
                error={endTimeError}
                type="time"
              />
            )}
          </FormLayout.Group>
          <FormLayout.Group>
            <Select
              label="Location"
              options={[
                { label: "Default Location", value: "default" },
                { label: "Other", value: "other" },
              ]}
              onChange={handleChangeLocation}
              value={item.location}
              placeholder="Please select"
              error={locationError}
            />
            {item.location === "other" ? (
              <TextField
                value={item.location_other}
                onChange={handleChangeLocationOther}
                label="Other Location"
                error={otherLocationError}
              />
            ) : null}
          </FormLayout.Group>
          <Select
            label="Room"
            options={optionsRooms}
            onChange={handleChangeRoom}
            value={item.room}
            placeholder="Please select"
          />
          <Select
            label="Gender"
            options={optionsGenders}
            onChange={handleSelectChangeGender}
            value={item.gender}
            placeholder="Please select"
            error={genderError}
          />
          {(item.gender === "male" || item.gender === "mixed") &&
            classType !== "duration" && (
              <TextField
                value={item.capacity_male}
                onChange={handleChangeCapacityMale}
                label="Male Capacity"
                error={maleCapacityError}
                type="number"
              />
            )}
          {(item.gender === "female" || item.gender === "mixed") &&
            classType !== "duration" && (
              <TextField
                value={item.capacity_female}
                onChange={handleChangeCapacityFemale}
                label="Female Capacity"
                error={femaleCapacityError}
                type="number"
              />
            )}
          {item.gender === "mixed_total" && classType !== "duration" && (
            <TextField
              value={item.total_capacity}
              onChange={handleChangeCapacityTotal}
              label="Total Capacity"
              error={totalCapacityError}
              type="number"
            />
          )}
          <TextField
            value={item.external_capacity}
            onChange={handleChangeExternalCapacity}
            label="External Capacity"
            type="number"
          />
          <Checkbox
            label="Is Online"
            checked={item.is_online}
            onChange={handleChangeIsOnline}
          />
          {item.is_online && (
            <TextField
              value={item.zoom_meeting_url}
              onChange={handleChangeZoomMeetingUrl}
              label="Zoom Meeting URL"
              type="url"
            />
          )}
          <Checkbox
            label="Is Discount Enabled"
            checked={item.is_discount_enabled}
            onChange={handleChangeIsDiscountEnabled}
          />

          {classType === "duration" && (
            <FormLayout>
              <Divider borderColor="border-inverse" />
              <Text as="p" fontWeight="semibold">
                AVAILABLE TIME RANGES
              </Text>
              {item.time_ranges?.map((range, index) => (
                <div key={index}>
                  <FormLayout.Group condensed>
                    <TextField
                      type="time"
                      label="From"
                      value={range.from_time}
                      onChange={(value) =>
                        handleChangeTime(index, "from_time", value)
                      }
                    />
                    <TextField
                      type="time"
                      label="To"
                      value={range.to_time}
                      onChange={(value) =>
                        handleChangeTime(index, "to_time", value)
                      }
                      connectedRight={
                        <Button
                          onClick={() => handleRemoveTime(index)}
                          variant="primary"
                          tone="critical"
                        >
                          Remove
                        </Button>
                      }
                    />
                  </FormLayout.Group>
                </div>
              ))}
              <Button fullWidth variant="primary" onClick={handleAddTime}>
                Add Time
              </Button>
              {/* 
              {JSON.stringify(
                item.time_slots.map(({ start_time, end_time }) => ({
                  start_time,
                  end_time,
                }))
              )} */}
            </FormLayout>
          )}

          {/* {classType === "spot" && (
            <FormLayout>
              <Divider borderColor="border-inverse" />
              <Text as="p" fontWeight="semibold">
                SPOTS
              </Text>
              <TextField
                value={item.canvas_height}
                onChange={handleChangeTimeCanvasHeight}
                label="Canvas Height"
                error={canvasHeightError}
                type="number"
                prefix="%"
              />
              <Text>Instructor Position</Text>
              <FormLayout.Group condensed>
                <TextField
                  value={item.instructor_x}
                  onChange={handleChangeTimeInstructorX}
                  label="x"
                  type="number"
                  prefix="%"
                  error={instructorXError}
                />
                <TextField
                  value={item.instructor_y}
                  onChange={handleChangeTimeInstructorY}
                  label="y"
                  type="number"
                  prefix="%"
                  error={instructorYError}
                />
                <TextField
                  value={item.instructor_rotation}
                  onChange={handleChangeTimeInstructorRotation}
                  label="Rotation"
                  type="number"
                  prefix="°"
                  error={instructorRotationError}
                />
              </FormLayout.Group>
              <Text>Seats</Text>
              {item.spots?.map((spot, index) => (
                <div key={index}>
                  <FormLayout>
                    <FormLayout.Group condensed>
                      <TextField
                        type="number"
                        prefix="%"
                        label="x"
                        value={spot.position_x}
                        onChange={(value) =>
                          handleChangeSpot(index, "position_x", value)
                        }
                      />
                      <TextField
                        type="number"
                        prefix="%"
                        label="y"
                        value={spot.position_y}
                        onChange={(value) =>
                          handleChangeSpot(index, "position_y", value)
                        }
                      />
                      <TextField
                        type="number"
                        prefix="°"
                        label="Rotation"
                        value={spot.rotation}
                        onChange={(value) =>
                          handleChangeSpot(index, "rotation", value)
                        }
                      />
                      <TextField
                        label="Label"
                        value={spot.label}
                        onChange={(value) =>
                          handleChangeSpot(index, "label", value)
                        }
                        connectedRight={
                          <Button
                            onClick={() => handleRemoveSpot(index)}
                            variant="primary"
                            tone="critical"
                          >
                            Remove
                          </Button>
                        }
                      />
                    </FormLayout.Group>
                    <Checkbox
                      label="Active"
                      checked={parseInt(spot.is_active) ? true : false}
                      onChange={(value) =>
                        handleChangeSpot(index, "is_active", value)
                      }
                    />
                    <Checkbox
                      label="Booked"
                      checked={parseInt(spot.is_booked) ? true : false}
                      onChange={(value) =>
                        handleChangeSpot(index, "is_booked", value)
                      }
                    />
                    <Divider borderColor="border-inverse" />
                  </FormLayout>
                </div>
              ))}
              <Button
                fullWidth
                variant="primary"
                onClick={handleAddSpot}
                icon={PlusIcon}
              >
                Add Seat
              </Button>
            </FormLayout>
          )} */}
          {/* <div style={{ height: "100px" }}></div> */}

          {item.is_private ? (
            <FormLayout>
              <Text as="p" fontWeight="bold">
                BOOK
              </Text>
              <Text>User</Text>
              <Select2
                options={optionsUsers}
                onChange={handleChangeUser}
                value={user}
                placeholder="Please select"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: "100px",
                    overflowY: "auto",
                    zIndex: 9999,
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: "100px",
                  }),
                }}
                menuPosition="absolute"
              />
              <InlineError message={userError}></InlineError>
              <Select
                label="Payment Method"
                options={[
                  { label: "Wallet", value: "wallet" },
                  {
                    label: "Offline Card",
                    value: "offline_card",
                  },
                  { label: "Cash ", value: "cash" },
                ]}
                onChange={handleChangeMethod}
                value={method}
                error={methodError}
                placeholder="Please select"
              />
              {classType === "spot" ? (
                <Select
                  label="Seat"
                  options={seats}
                  onChange={handleChangeSeat}
                  value={seat}
                  error={seatError}
                  placeholder="Please select"
                />
              ) : null}
              <InlineError message={error} />
            </FormLayout>
          ) : null}

          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeTimeActive}
          />
          <InlineError message={error} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              disabled={item.is_booking_exists}
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(
                    `/${
                      props?.is_course === "yes" ? "courses" : "classes"
                    }/${id}/sessions/${sessionId}`
                  )
                  .then((result) => {
                    navigate(
                      `/admin/${
                        props?.is_course === "yes" ? "courses" : "classes"
                      }/${id}/sessions`
                    );
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    console.log(item.class);
    if (
      !item.date ||
      // item.instructor === "" ||
      (!item.start_time && classType !== "duration") ||
      (!item.end_time && classType !== "duration") ||
      !item.gender ||
      ((item.gender === "male" || item.gender === "mixed") &&
        classType !== "duration" &&
        item.capacity_male === "") ||
      ((item.gender === "female" || item.gender === "mixed") &&
        classType !== "duration" &&
        item.capacity_female === "") ||
      (item.gender === "mixed_total" &&
        classType !== "duration" &&
        item.total_capacity === "") ||
      !item.location ||
      (item.location === "other" && !item.location_other)
    ) {
      !item.date && setDateError("This field is required");
      // item.instructor === "" &&
      //   setInstructorError("Please choose an instructor");
      !item.start_time &&
        classType !== "duration" &&
        setStartTimeError("This field is required");
      !item.end_time &&
        classType !== "duration" &&
        setEndTimeError("This field is required");
      !item.gender && setGenderError("Please choose an option");
      (item.gender === "male" || item.gender === "mixed") &&
        classType !== "duration" &&
        item.capacity_male === "" &&
        setMaleCapacityError("This field is required");

      (item.gender === "female" || item.gender === "mixed") &&
        classType !== "duration" &&
        item.capacity_female === "" &&
        setFemaleCapacityError("This field is required");
      item.gender === "mixed_total" &&
        classType !== "duration" &&
        item.total_capacity === "" &&
        setTotalCapacityError("This field is required");
      !item.location && setLocationError("Please choose an option");
      item.location === "other" &&
        !item.location_other &&
        setOtherLocationError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("date", item.date);
      item.instructor !== "" &&
        props.is_course !== "yes" &&
        form_data.append("instructor_id", item.instructor.value);

      props.is_course === "yes" &&
        item.instructors.length &&
        item.instructors.forEach((selected, index) =>
          form_data.append(`instructors[${index}]`, selected.value)
        );

      form_data.append("is_active", item.isActive ? 1 : 0);
      classType !== "duration" &&
        form_data.append(
          props.is_course === "yes" ? "start_time" : "launch_time",
          item.start_time
        );
      classType !== "duration" &&
        form_data.append(
          props.is_course === "yes" ? "end_time" : "finish_time",
          item.end_time
        );
      form_data.append("gender", item.gender);
      (item.gender === "male" || item.gender === "mixed") &&
        form_data.append("capacity_male", item.capacity_male);
      (item.gender === "female" || item.gender === "mixed") &&
        form_data.append("capacity_female", item.capacity_female);
      item.gender === "mixed_total" &&
        form_data.append("capacity", item.total_capacity);
      if (classType === "duration") {
        item.time_ranges.forEach((selected, index) => {
          form_data.append(`time[${index}][from_time]`, selected.from_time);
          form_data.append(`time[${index}][to_time]`, selected.to_time);
        });
      }
      form_data.append("location", item.location);
      form_data.append("other_location", item.location_other);
      form_data.append("room_id", item.room);
      user !== null && user !== "" && form_data.append("user_id", user.value);
      method && form_data.append("payment_method", method);
      classType === "spot" &&
        item.seat !== "" &&
        form_data.append("reserved_seat_id", seat);
      form_data.append("name", item.name);
      form_data.append("description", item.description);
      props?.type === "edit" && form_data.append("class_id", item.class.value);
      form_data.append("external_capacity", item.external_capacity);
      form_data.append("is_online", item.is_online ? 1 : 0);
      item.is_online &&
        form_data.append("zoom_meeting_url", item.zoom_meeting_url);
      form_data.append("is_discount_enabled", item.is_discount_enabled ? 1 : 0);

      // if (classType === "spot") {
      //   form_data.append(
      //     "seats_general_settings[canvas_height]",
      //     item.canvas_height
      //   );
      //   form_data.append(
      //     "seats_general_settings[instructor][position_x]",
      //     item.instructor_x
      //   );
      //   form_data.append(
      //     "seats_general_settings[instructor][position_y]",
      //     item.instructor_y
      //   );
      //   form_data.append(
      //     "seats_general_settings[instructor][rotation]",
      //     item.instructor_rotation
      //   );
      //   item.spots.forEach((selected, index) => {
      //     form_data.append(
      //       `seats_positions[${index}][position_x]`,
      //       selected.position_x
      //     );
      //     form_data.append(
      //       `seats_positions[${index}][position_y]`,
      //       selected.position_y
      //     );
      //     form_data.append(
      //       `seats_positions[${index}][rotation]`,
      //       selected.rotation
      //     );
      //     form_data.append(`seats_positions[${index}][label]`, selected.label);
      //     form_data.append(
      //       `seats_positions[${index}][is_active]`,
      //       selected.is_active ? 1 : 0
      //     );
      //     form_data.append(
      //       `seats_positions[${index}][is_booked]`,
      //       selected.is_booked ? 1 : 0
      //     );
      //   });
      // }

      props.type === "edit" && form_data.append("_method", "PATCH");

      props.type === "add"
        ? axios
            .post(
              `/${
                props?.is_course === "yes" ? "courses" : "classes"
              }/${id}/sessions`,
              form_data
            )
            .then((result) => {
              navigate(
                `/admin/${
                  props?.is_course === "yes" ? "courses" : "classes"
                }/${id}/sessions`
              );
            })
            .catch((error) => {
              console.log("error=", error.response.data.message);
              classType === "duration" && setError(error.response.data.message);
              setIsSaving(false);
            })
        : axios
            .post(
              `/${
                props?.is_course === "yes" ? "courses" : "classes"
              }/${id}/sessions/${sessionId}`,
              form_data
            )
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((error) => {
              console.log("error=", error.response.data.message);
              setIsSaving(false);
              setError(error.response.data.message);
              // if (error.response) {
              //   setPasswordError(
              //     <ul>
              //       {error.response.data.errors.password.map(
              //         (element, index) => {
              //           return (
              //             <div key={index}>
              //               <h2>{element}</h2>
              //             </div>
              //           );
              //         }
              //       )}
              //     </ul>
              //   );
              // } else if (error.request) {
              //   console.log(error.request);
              // } else {
              //   console.log("Error", error.message);
              // }
              console.log(error.config);
            });
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default AddEditSession;
